'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keyframes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var speeds = {
  snail: 5,
  slow: 3,
  medium: 2,
  fast: 1
};

exports.default = function (_ref, _ref2, keyframes) {
  var background = _ref.background,
      foreground = _ref.foreground,
      _ref$items = _ref.items,
      items = _ref$items === undefined ? [] : _ref$items,
      labelBackground = _ref.labelBackground,
      labelForeground = _ref.labelForeground,
      spacing = _ref.spacing,
      speed = _ref.speed,
      styles = _ref.styles;
  var colors = _ref2.colors,
      rhythm = _ref2.rhythm,
      treatments = _ref2.treatments;
  return (0, _merge2.default)({
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: rhythm(2.5),
      backgroundColor: colors[background],
      color: colors[foreground]
    },

    label: _extends({
      position: 'absolute',
      left: 0,
      top: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexPack: 'center',
      padding: rhythm(0.5) + ' ' + rhythm(1),
      backgroundColor: colors[labelBackground],
      color: colors[labelForeground],
      boxShadow: '0.5rem 0 3rem ' + colors[background]
    }, treatments.head),

    items: {
      position: 'absolute',
      top: '50%',
      left: 0,
      paddingLeft: '100%',
      animation: keyframes.marquee + ' linear infinite',
      whiteSpace: 'nowrap',
      animationDuration: Math.max(10, items.length * speeds[speed]) + 's'
    },

    item: {
      display: 'inline-block',
      marginRight: rhythm(1)
    }
  }, styles);
};

var keyframes = exports.keyframes = {
  marquee: {
    '0%': {
      transform: 'translate(0, -50%)'
    },
    '100%': {
      transform: 'translate(-100%, -50%)'
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/ticker/styles.js
// module id = 921
// module chunks = 0